<template>
  <section>
    <div class="row mb-2">
      <div class="col-md-12">
        <button class="btn btn-primary btn-sm" @click="add">Add</button>
      </div>
    </div>
    <div class="custom-resources">
      <z-table
        :value="resources"
        :columns="tableColumns"
        :isSingleRowDetail="false"
        class="table table-bordered table-striped"
        detailColumnClass="z-column-60-center"
        :loading="isLoading"
      >
        <template v-slot:tbody="props">
          <td class="z-column-60-center">
            <a href="#" @click="edit(props.row.id)">edit</a>
          </td>
          <td>{{ props.row.name }}</td>
          <td>
            <span class="custom-date-range"
              >{{ formatDate(props.row.visibility_start_date) }} -
              {{ formatDate(props.row.visibility_end_date) }}</span
            >
          </td>
          <td class="z-column-160-center">{{ props.row.required_time }}</td>
          <td
            class="z-column-60-center"
            @mouseenter="showSpin = props.row.id"
            @mouseleave="showSpin = null"
          >
            <z-stepper
              v-if="showSpin === props.row.id"
              @clickUp="stepperClickedUp(props.row)"
              @clickDown="stepperClickedDown(props.row)"
            />
          </td>
          <td class="z-column-60-center">
            <a href="#" @click="view(props.row.url)">view</a>
          </td>
          <td class="z-column-60-center">
            <a href="#" @click="remove(props.row.id)">remove</a>
          </td>
        </template>
        <template v-slot:empty> Nothing found! </template>
      </z-table>
    </div>
  </section>
  <resource-dialog
    :resource="actionResource"
    @close="closeModal"
    @save="saveResource"
  />
  <confirm-remove
    :show="actionConfirmRemove"
    :confirmTitle="confirmTitleRemove"
    :confirmAction="confirmActionRemove"
    :confirmQuestion="confirmQuestionRemove"
    @closing="closeModal"
    @proceed="performRemove"
  />
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import globals from '@/Plugins/globals'
import ZTable from '@/Components/ZElements/Table'
import ZStepper from '@/Components/ZElements/Stepper'
import ConfirmRemove from '@/Components/ZElements/ConfirmDialog'
import ResourceDialog from './resource-dialog'
export default {
  name: 'challenge-resources',
  components: {
    ZTable,
    ZStepper,
    ConfirmRemove,
    ResourceDialog,
  },
  data() {
    return {
      isLoading: false,
      showSpin: null,
      confirmTitleRemove: 'Confirm Removal',
      confirmActionRemove: 'Remove',
      confirmQuestionRemove: 'Are you sure you wish to remove this Resource?',
      actionConfirmRemove: null,
      actionResource: null,
    }
  },
  mounted() {
    this.isLoading = false
  },
  emits: ['saveIt'],
  computed: {
    ...mapGetters('challenges', ['challenge']),
    tableColumns() {
      return [
        {
          field: 'id',
          label: '',
          sortable: false,
          class: 'z-column-60-center',
        },
        { field: 'Name', label: 'Name', sortable: false },
        {
          field: 'visibility_start_date',
          label: 'Date Range',
          sortable: false,
        },
        {
          field: 'required_time',
          label: 'Required Time',
          sortable: false,
          class: 'z-column-160-center',
        },
        {
          field: 'id',
          label: 'sort',
          sortable: false,
          class: 'z-column-60-center',
        },
        {
          field: 'id',
          label: '',
          sortable: false,
          class: 'z-column-60-center',
        },
        {
          field: 'id',
          label: '',
          sortable: false,
          class: 'z-column-60-center',
        },
      ]
    },
    resources: {
      get() {
        let _data = []
        if (this.challenge) {
          if (this.challenge.resources) {
            _data = this.challenge.resources
          }
        }
        return _data
      },
    },
  },
  methods: {
    ...mapActions('challenges', ['setChallengeData']),
    formatDate(date) {
      return moment.utc(new Date(date)).format('MM/DD/YYYY')
    },
    edit(id) {
      console.log('Editing', id)
      let found = this.resources.find((x) => parseInt(x.id) === parseInt(id))
      if (found) {
        this.actionResource = {
          id: found.id,
          name: found.name,
          url: found.url,
          required_time:
            found.required_time !== null ? found.required_time : 300,
          startDate: moment(new Date(found.visibility_start_date)).format(
            'YYYY-MM-DD'
          ),
          endDate: moment(new Date(found.visibility_end_date)).format(
            'YYYY-MM-DD'
          ),
        }
      }
      this.$emit('saveIt')
    },
    add() {
      this.actionResource = {
        id: null,
        name: '',
        url: '',
        required_time: 300,
        startDate: moment(new Date(this.challenge.visible_date)).format(
          'YYYY-MM-DD'
        ),
        endDate: moment(new Date(this.challenge.end_date)).format('YYYY-MM-DD'),
      }
      console.log('Adding', this.actionResource)
    },
    view(url) {
      window.open(url, '_blank')
    },
    async stepperClickedUp(row) {
      this.showSpin = null
      this.setChallengeData({
        name: 'sort',
        value: row.id,
        direction: 'up',
      })
      this.showSpin = null
      this.$emit('saveIt')
    },
    async stepperClickedDown(row) {
      this.showSpin = null
      this.setChallengeData({
        name: 'sort',
        value: row.id,
        direction: 'down',
      })
      this.showSpin = null
      this.$emit('saveIt')
    },
    saveResource(data) {
      if (data.id !== null) {
        this.setChallengeData({
          name: 'edit-resource',
          value: data,
        })
      } else {
        this.setChallengeData({
          name: 'add-resource',
          value: data,
        })
      }
      this.actionResource = null
      this.$emit('saveIt')
    },
    closeModal() {
      this.actionConfirmRemove = null
      this.actionResource = null
    },
    remove(id) {
      this.itemId = id
      this.actionConfirmRemove = true
    },
    performRemove() {
      this.setChallengeData({
        name: 'remove-resource',
        value: this.itemId,
      })
      this.itemId = null
      this.actionConfirmRemove = null
      this.$emit('saveIt')
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-resources {
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 370px;
}
.custom-group-item {
  position: relative;
  min-height: 40px;
  a {
    text-decoration: none;
    cursor: pointer;
  }
  // button {
  //   position: absolute;
  //   top: -5px;
  //   right: -5px;
  //   color: red;
  //   width: 32px;
  //   padding: 0;
  //   margin: 0;
  // }
}
.custom-date-range {
  position: relative;
}
.custom-date-label {
  margin-right: 5px;
}
.custom-action {
  padding-top: 8px;
  font-weight: 400;
  width: 90%;
  height: 40px;
}
</style>
